import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
} from "reactstrap";
import Select from "../../Common/AppSelect";
import filterActiveStaff from "../../Common/staffActive";
import { isEmpty } from "lodash";
import React, { forwardRef, useEffect, useRef, useState } from "react";
// Change #100070 - read a customer's default contract item when the customer
// list does not carry it yet.
import { FetchAPI } from "../../../helpers/APIdata/fetchAPI";
import { useDispatch, useSelector } from "react-redux";
import { getStaffList, searchStaff } from "../../../store/staff/action";
import {
  addJobSuccess,
  addNewJob as onAddNewJob,
  createRecurringJob,
  createRecurringJobSuccess,
  getJobsData,
  getJobsPriorityData,
  getJobStatusData,
  getJobsTypeData,
  getRecurringJobsList,
  getSingleCustomerJobsList,
  getUninvoicedJobsList,
  updateJob as onUpdateJob,
  updateJobSuccess,
  updateRecurringJob,
  updateRecurringJobSuccess,
} from "../../../store/jobsList/actions";
import "./jobCreateEdit.styles.scss";
import {
  getCustomersListData,
  getSingleCustomerSiteLocationListData,
} from "../../../store/customers/action";
import { toast } from "react-toastify";
// Change #100256 - start / assign the timer on the job just created.
import {
  timeEntryReduxStateDataSuccess,
  timerIsRunning,
  actionEventFiredSuccess,
} from "../../../store/timeEntries/action";
import {
  getContractUnitFrequencyList,
  searchSingleCustomerContractItemList,
} from "../../../store/contract/action";
import { useHistory } from "react-router-dom";
import {
  contactPersonSingleCompanySearch,
  searchPersonWithCustomerId,
} from "../../../store/people/action";
import classnames from "classnames";
import handleDateTime, {
  handleValidDateTime,
  RestructuredDate,
  timeFormatDateAndTime,
} from "../../Common/HandleDateTime";
import { handleDurationTime } from "../../Common/HandleDurationTime";
import moment from "moment/moment";
import { readSingleJob } from "../../../store/singleJob/action";
import RichTextEditor from "../../RichTextEditor";
import { CustomSelect } from "../../Common/CustomSelect";
import lexical from "lexical";
import { listVehicles } from "../../../store/vehicle/action";
import {
  isSystemModuleActive,
  SYSTEM_MODULE_CODES,
} from "../../../helpers/functions/systemModules";
import JobTasks from "./jobTasks";
import { handleCalculateHowManyMinutesBetweenTwoDates } from "../CreateEditTask/CreateEditTaskPopUp";
import CreateEditVehicle from "../CreateEditVehicle";
import CreateEditCustomer from "../CreateEditCustomer/CreateEditCustomer";
import CreateEditCustomerSiteLocation from "../CreateEditCustomerSiteLocation/CreateEditCustomerSiteLocation";
import ContinueOrCancel from "../ContinueOrCancel";
import { handleRichTextOutput } from "../../Common/HandleRichTextOutput";
import { Button } from "@mui/material";
import {
  AppDateTimePicker,
  AppDatePicker,
} from "../../Common/AppDateTimePicker";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import AppModal from "../../Common/AppModal";

export default function JobCreateEdit({
  toggle,
  isEdit,
  modal,
  setModal,
  singleJobEditData,
  singleCustomerPageEditCreate,
  singleCustomerPage_Customer_Id,
  cloneJob,
  setCloneJob,
  recurringJob,
  singleJobPage,
  page,
  singleEmail,
  createNewTaskWithDueDate,
  onJobCreated,
  initialCustomerId,
  // Change #100303 - "Convert to Job" on an opportunity: { Id, Title }.
  // Prefills the title and links the new job to the opportunity (its
  // description and notes show on the job's Opportunities tab).
  sourceOpportunity,
}) {
  // Helpers
  const dispatch = useDispatch();
  const history = useHistory();
  //Task Initial State
  const initialTaskData = {
    LID: 1,
    isOpen: true,
    Id: "",
    Title: "",
    Description: "",
    Customer_Id: singleCustomerPage_Customer_Id
      ? singleCustomerPage_Customer_Id
      : "",
    ContactPerson: "",
    Staff_Id: "",
    Project: "",
    TaskType_Id: "",
    TaskPriority_Id: "",
    TaskStatus_Id: "",
    Job_Id: "",
    DueDateTime: createNewTaskWithDueDate ? createNewTaskWithDueDate : "",
    StartDateTime: createNewTaskWithDueDate ? createNewTaskWithDueDate : "",
    EndDateTime:
      // createNewTaskWithDueDate +1 hour
      createNewTaskWithDueDate
        ? timeFormatDateAndTime(
            new Date(
              new Date(createNewTaskWithDueDate).setHours(
                new Date(createNewTaskWithDueDate).getHours() + 1
              )
            )
          )
        : "",
    FlagAllDay: "0",
    DurationMins: createNewTaskWithDueDate
      ? handleCalculateHowManyMinutesBetweenTwoDates(
          new Date(createNewTaskWithDueDate),
          new Date(
            new Date(createNewTaskWithDueDate).setHours(
              new Date(createNewTaskWithDueDate).getHours() + 1
            )
          )
        )
      : null,
    taskchecklisttemplate_list: [],
    Vehicle_Id: "",
    LocationLatitude: "",
    LocationLongitude: "",
    LocationAddressLine1: "",
    LocationAddressLine2: "",
    LocationAddressLine3: "",
    LocationAddressLine4: "",
    LocationAddressCity: "",
    LocationAddressCounty: "",
    LocationAddressPostcode: "",
    LocationAddressCountry: "",
  };

  //Job Initial State
  const initialJobCreateEdit = {
    Id: "",
    Title: singleEmail?.Subject ?? sourceOpportunity?.Title ?? "",
    Description: "",
    Customer_Id: "",
    // Change #100371 - who pays, when it is not the job's customer (e.g. an insurer
    // paying for a policyholder's job). Blank = the customer pays.
    BillToCustomer_Id: "",
    CustomerSiteLocation_Id: "",
    FlagUseManualAddress: 0,
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressLine4: "",
    AddressCity: "",
    AddressCounty: "",
    AddressPostCode: "",
    AddressCountry: "",
    Staff_Id: "",
    JobStatus_Id: "",
    JobPriority_Id: "",
    JobType_Id: "",
    ContractItem_Id: "",
    Person_Id: "",
    RecurringStartDateTime: null,
    RecurringEndDateTime: null,
    RecurringNextDateTime: null,
    UnitFrequency_Id: "",
    isRecurring: false,
    emailinbound_list: [
      {
        Id: singleEmail?.Id ?? "",
      },
    ],
    Vehicle_Id: "",
    CustomerReference: "",
    taskList: [initialTaskData],
    InvoiceSummaryText: "",
    CompletedDateTime: "",
  };
  // Local State
  const [jobCreateEdit, setJobCreateEdit] = useState(initialJobCreateEdit);

  // Change #100308 - Job Tags picked in this popup. Kept out of jobCreateEdit
  // because job/update does not take them: they are saved through
  // jobtojobtag/create + remove once the job itself has saved, so each add and
  // remove lands on the job's Change Log under the person who made it.
  const [jobTagLibrary, setJobTagLibrary] = useState([]);
  const [jobTagLiveRows, setJobTagLiveRows] = useState([]);
  const [jobTagSelected, setJobTagSelected] = useState([]);
  useEffect(() => {
    if (!modal) return undefined;
    let cancelled = false;
    FetchAPI("/jobtag/list", "GET")
      .then((response) => {
        if (!cancelled && response?.status === 200) {
          setJobTagLibrary(response.jobtag_list || []);
        }
      })
      .catch(() => {});
    const editingId = isEdit ? singleJobEditData?.Id : null;
    if (editingId) {
      FetchAPI("/jobtojobtag/search", "POST", [
        { jobtojobtag_data: { Job_Id: editingId } },
      ])
        .then((response) => {
          if (cancelled || response?.status !== 200) return;
          const rows = response.jobtojobtag_list || [];
          setJobTagLiveRows(rows);
          setJobTagSelected(rows.map((r) => String(r.JobTag_Id)));
        })
        .catch(() => {});
    } else {
      setJobTagLiveRows([]);
      setJobTagSelected([]);
    }
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal, isEdit, singleJobEditData?.Id]);

  // Bring the job's tags in line with what was picked: add the new ones,
  // remove the ones un-picked. Best-effort - the job has already saved.
  const syncJobTags = async (jobId) => {
    if (!jobId || !jobTagLibrary.length) return;
    const live = jobTagLiveRows.map((r) => String(r.JobTag_Id));
    const toAdd = jobTagSelected.filter((id) => !live.includes(id));
    const toRemove = jobTagLiveRows.filter(
      (r) => !jobTagSelected.includes(String(r.JobTag_Id))
    );
    if (!toAdd.length && !toRemove.length) return;
    if (toAdd.length) {
      await FetchAPI(
        "/jobtojobtag/create",
        "POST",
        toAdd.map((JobTag_Id) => ({ Job_Id: jobId, JobTag_Id }))
      );
    }
    if (toRemove.length) {
      await FetchAPI(
        "/jobtojobtag/remove",
        "PUT",
        toRemove.map((r) => ({ Id: r.Id, RemovedNote: "Removed in Edit job" }))
      );
    }
    // The job header's Tags row reloads on this.
    window.dispatchEvent(
      new CustomEvent("crmit:jobtags-changed", { detail: { jobId } })
    );
  };
  console.log("jobCreateEdit", jobCreateEdit);
  const [createAndViewJob, setCreateAndViewJob] = useState(false);

  // Change #100256 - "we need a tickbox which either starts the timer if not
  // running or assigns the timer when checked, after clicking create. We have
  // this at task level so just copy that" (CreateEditTaskPopUp, Tasks
  // 24610 / 24880). Same two outcomes, same house mechanism.
  const [startTimerOnSave, setStartTimerOnSave] = useState(false);
  const { timerEntryData, timerRunning } = useSelector((state) => ({
    timerEntryData: state.TimeEntries?.timeEntryData?.timeentry_data,
    timerRunning: state.TimeEntries?.timeEntryData?.timeentry_data?.timerIsRunning,
  }));
  const [localJobUpdate, setLocalJobUpdate] = useState(false);
  const [isClearEditor, setIsClearEditor] = useState(false);
  const [continueWithCreatingNewJob, setContinueWithCreatingNewJob] =
    useState(false);

  // Redux State
  const { customersList } = useSelector((state) => ({
    customersList: state.Customers?.customersDataList?.customer_list,
  }));
  const { staffData } = useSelector((state) => ({
    staffData: state.Staff.searchStaffSuccess?.staff_list,
  }));
  const { jobsTypeList } = useSelector((state) => ({
    jobsTypeList: state.Jobs.jobTypeList?.jobtype_list,
  }));

  const { jobPriorityList } = useSelector((state) => ({
    jobPriorityList: state.Jobs.jobPriorityList?.jobpriority_list,
  }));
  const { jobStatusList } = useSelector((state) => ({
    jobStatusList: state.Jobs.jobStatusData?.jobstatus_list,
  }));
  const { contractItemsList } = useSelector((state) => ({
    contractItemsList:
      state.Contract.singleCustomerContractItemsList.contractitem_list,
  }));

  // Change #100070 - "when creating a new job this default value didn't carry
  // through to the create job page and set the contract item field
  // automatically on load". A customer's Default Contract Item (set on the
  // customer's Overview) now pre-fills Contract Item on a NEW job as soon as
  // the customer is known - passed in, or picked here.
  //   - only while Contract Item is empty or still holds the default we filled
  //     in, so a contract item the user chose is never overwritten;
  //   - picking a different customer swaps an auto-filled default for theirs;
  //   - only if that contract item is one jobs can be allocated to (it is in
  //     contractItemsList).
  const autoContractItemRef = useRef(null);
  useEffect(() => {
    if (isEdit) return undefined;
    const customerId = jobCreateEdit?.Customer_Id;
    if (!customerId) return undefined;
    let cancelled = false;

    (async () => {
      const fromList = (customersList || []).find(
        (c) => String(c.Id) === String(customerId)
      );
      let defaultId = fromList ? fromList.DefaultContractItem_Id : undefined;
      if (defaultId === undefined) {
        // Older backend: the list has no DefaultContractItem_Id column yet.
        const response = await FetchAPI(`/customer/data/${customerId}`, "GET");
        defaultId = response?.customer_data?.DefaultContractItem_Id;
      }
      if (cancelled) return;

      const usable =
        defaultId &&
        (contractItemsList || []).some((ci) => String(ci.Id) === String(defaultId));

      setJobCreateEdit((prev) => {
        if (String(prev.Customer_Id) !== String(customerId)) return prev;
        const current = prev.ContractItem_Id;
        const currentIsAuto =
          !!current && String(current) === String(autoContractItemRef.current);
        if (current && !currentIsAuto) return prev; // the user chose one
        const next = usable ? defaultId : "";
        autoContractItemRef.current = next || null;
        if (String(current || "") === String(next || "")) return prev;
        return { ...prev, ContractItem_Id: next };
      });
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobCreateEdit?.Customer_Id, isEdit, contractItemsList, customersList]);
  // Change #100476 - "site location too confusing". A job goes to one of three
  // places and the form only had a Site Location / Manual Address switch, with
  // "the customer's own address" implied by leaving the site blank and no
  // address shown anywhere. There is still no third column: FlagUseManualAddress
  // = 1 is a typed address, a CustomerSiteLocation_Id is a site, neither is the
  // customer's address. sitePending only keeps "A site location" selected while
  // no site has been picked yet.
  const [sitePending, setSitePending] = useState(false);
  const jobAddressMode = Number(jobCreateEdit?.FlagUseManualAddress) === 1
    ? "manual"
    : jobCreateEdit?.CustomerSiteLocation_Id || sitePending
    ? "site"
    : "customer";
  const applyJobAddressMode = (mode) => {
    setSitePending(mode === "site");
    setJobCreateEdit((prev) => ({
      ...prev,
      FlagUseManualAddress: mode === "manual" ? 1 : 0,
      CustomerSiteLocation_Id: mode === "site" ? prev.CustomerSiteLocation_Id : null,
    }));
  };
  useEffect(() => {
    setSitePending(false);
  }, [jobCreateEdit?.Customer_Id]);

  // The customer's own address, for the "this job will go to" line. The list
  // row has it when the customer came from the picker; otherwise (opened from
  // the customer page, or just created) it is read once from /customer/data.
  const [customerAddress, setCustomerAddress] = useState(null);
  useEffect(() => {
    const customerId = jobCreateEdit?.Customer_Id;
    if (!customerId) {
      setCustomerAddress(null);
      return undefined;
    }
    let cancelled = false;
    const fromList = (customersList || []).find(
      (c) => String(c.Id) === String(customerId)
    );
    if (fromList && (fromList.AddressLine1 || fromList.AddressPostCode)) {
      setCustomerAddress(fromList);
      return undefined;
    }
    FetchAPI(`/customer/data/${customerId}`, "GET")
      .then((response) => {
        if (cancelled) return;
        const raw = response?.customer_data;
        setCustomerAddress((Array.isArray(raw) ? raw[0] : raw) || fromList || null);
      })
      .catch(() => !cancelled && setCustomerAddress(fromList || null));
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobCreateEdit?.Customer_Id]);

  const addressText = (a) =>
    a
      ? [
          a.AddressLine1,
          a.AddressLine2,
          a.AddressLine3,
          a.AddressLine4,
          a.AddressCity,
          a.AddressCounty,
          a.AddressPostCode,
        ]
          .map((p) => (p == null ? "" : String(p).trim()))
          .filter(Boolean)
          .join(", ")
      : "";

  const { PeopleList } = useSelector((state) => ({
    PeopleList: state.People.searchPersonWithCustomerId?.contactperson_list,
  }));

  const { ContractUnitFrequencyListApi } = useSelector((state) => ({
    ContractUnitFrequencyListApi:
      state.Contract.contractUnitFrequencyList?.unitfrequency_list,
  }));
  const { vehicleListAPI } = useSelector((state) => ({
    vehicleListAPI: state.Vehicle.vehicleList?.vehicle_list,
  }));
  const {
    singleCustomerSiteLocationListAPI,
    singleCustomerSiteLocationListAPILoading,
  } = useSelector((state) => ({
    singleCustomerSiteLocationListAPI:
      state.Customers.singleCustomerSiteLocationList?.customersitelocation_list,
    singleCustomerSiteLocationListAPILoading:
      state.Customers.singleCustomerSiteLocationListLoading,
  }));

  useEffect(() => {
    if (isEmpty(jobCreateEdit.Customer_Id)) return;
    dispatch(
      searchPersonWithCustomerId([
        {
          customer_data: {
            Id: jobCreateEdit.Customer_Id,
          },
        },
      ])
    );
    dispatch(
      getSingleCustomerSiteLocationListData([
        {
          customer_data: {
            Id: jobCreateEdit.Customer_Id,
          },
        },
      ])
    );
  }, [jobCreateEdit.Customer_Id]);
  // UseEffect
  useEffect(() => {
    // Staff Date

    dispatch(
      searchStaff([
        {
          staff_data: {
            FlagAllowJob: "1",
          },
        },
      ])
    );

    // Get Status List

    dispatch(getJobStatusData());

    dispatch(getJobsTypeData());

    dispatch(getJobsPriorityData());

    dispatch(getCustomersListData());
    dispatch(listVehicles());
    dispatch(
      searchSingleCustomerContractItemList([
        {
          contractitem_data: {
            AllowedJobAllocation: "1",
          },
        },
      ])
    );
    dispatch(getContractUnitFrequencyList());
  }, []);

  useEffect(() => {
    if (isEdit) return;
    if (singleCustomerPageEditCreate) {
      setJobCreateEdit({
        ...initialJobCreateEdit,
        Customer_Id: singleCustomerPage_Customer_Id,
      });
    }
  }, [isEdit]);

  // Pre-fill the customer when the create modal is opened from a context that
  // already knows it (e.g. "Create & Link Job" from a task with a customer set).
  // Guarded so it never overwrites a customer the user has already chosen, and
  // re-runs if the customer id arrives after the modal has mounted.
  useEffect(() => {
    if (isEdit || singleCustomerPageEditCreate) return;
    if (isEmpty(initialCustomerId)) return;
    setJobCreateEdit((prev) =>
      isEmpty(prev.Customer_Id)
        ? { ...prev, Customer_Id: initialCustomerId }
        : prev
    );
  }, [initialCustomerId, isEdit]);

  const handleCreateJob = (continueWithCreation) => {
    console.log("******Create New Hob action Fired");
    //Check if title is not empty if it is toast error
    if (jobCreateEdit.Title === "") {
      toast.error("Please enter job title");
      return;
    }
    if (isEmpty(jobCreateEdit.Customer_Id)) {
      toast.error("Please Select Customer");
      return;
    }
    // check if status is not empty if it is toast error
    if (isEmpty(jobCreateEdit.JobStatus_Id)) {
      toast.error("Please select job status");
      return;
    }

    if (!jobCreateEdit.ContractItem_Id) {
      console.log("continueWithCreatingNewJob", continueWithCreatingNewJob);
      console.log("continueWithCreation", continueWithCreation);
      if (!continueWithCreation) {
        if (!continueWithCreatingNewJob) {
          if (
            contractItemsList?.some(
              (item) => item.Customer_Id === jobCreateEdit.Customer_Id
            )
          ) {
            setContinueOrCancelModal(true);
            return;
          }
        }
      }
    }

    const createNewJobData = {
      Title: jobCreateEdit.Title,
      Description: jobCreateEdit.Description,
      Customer_Id: jobCreateEdit.Customer_Id,
      // Change #100371 - only sent when set, so a company whose database has not
      // had the column added yet creates jobs exactly as before.
      ...(jobCreateEdit.BillToCustomer_Id && {
        BillToCustomer_Id: jobCreateEdit.BillToCustomer_Id,
      }),
      // Location: mutually exclusive site-location link vs typed address.
      FlagUseManualAddress: jobCreateEdit?.FlagUseManualAddress ? 1 : 0,
      CustomerSiteLocation_Id: jobCreateEdit?.FlagUseManualAddress
        ? null
        : jobCreateEdit.CustomerSiteLocation_Id,
      AddressLine1: jobCreateEdit?.FlagUseManualAddress ? jobCreateEdit?.AddressLine1 : null,
      AddressLine2: jobCreateEdit?.FlagUseManualAddress ? jobCreateEdit?.AddressLine2 : null,
      AddressLine3: jobCreateEdit?.FlagUseManualAddress ? jobCreateEdit?.AddressLine3 : null,
      AddressLine4: jobCreateEdit?.FlagUseManualAddress ? jobCreateEdit?.AddressLine4 : null,
      AddressCity: jobCreateEdit?.FlagUseManualAddress ? jobCreateEdit?.AddressCity : null,
      AddressCounty: jobCreateEdit?.FlagUseManualAddress ? jobCreateEdit?.AddressCounty : null,
      AddressPostCode: jobCreateEdit?.FlagUseManualAddress ? jobCreateEdit?.AddressPostCode : null,
      AddressCountry: jobCreateEdit?.FlagUseManualAddress ? jobCreateEdit?.AddressCountry : null,
      Staff_Id: jobCreateEdit.Staff_Id,
      JobStatus_Id: jobCreateEdit.JobStatus_Id,
      JobPriority_Id: jobCreateEdit.JobPriority_Id,
      JobType_Id: jobCreateEdit.JobType_Id,
      // if ContractItem_Id is empty then dont send this property at all
      ...(jobCreateEdit.ContractItem_Id && {
        ContractItem_Id: jobCreateEdit.ContractItem_Id,
      }),
      ...(jobCreateEdit.Person_Id && {
        Person_Id: jobCreateEdit.Person_Id,
      }),
      RecurringNextDateTime: jobCreateEdit?.RecurringNextDateTime,
      RecurringStartDateTime: jobCreateEdit?.RecurringStartDateTime,
      RecurringEndDateTime: jobCreateEdit?.RecurringEndDateTime,
      UnitFrequency_Id: jobCreateEdit?.UnitFrequency_Id,

      fileattachment_list: jobCreateEdit?.fileattachment_list,
      emailinbound_list: jobCreateEdit?.emailinbound_list,
      Vehicle_Id: jobCreateEdit?.Vehicle_Id,
      CustomerReference: jobCreateEdit?.CustomerReference,
      task_list: jobCreateEdit?.taskList,
      InvoiceSummaryText: jobCreateEdit?.InvoiceSummaryText,
      CompletedDateTime: jobCreateEdit?.CompletedDateTime,
      // Change #100303 - only sent when converting, so other creates are unchanged.
      ...(sourceOpportunity?.Id && { Opportunity_Id: sourceOpportunity.Id }),
    };

    if (!jobCreateEdit.isRecurring) {
      dispatch(onAddNewJob([createNewJobData]));
    } else {
      dispatch(createRecurringJob([createNewJobData]));
    }
    if (cloneJob) {
      setCloneJob(false);
    }
    setIsClearEditor(!isClearEditor);
  };

  const { createRecurringJobSuccessApi } = useSelector((state) => ({
    createRecurringJobSuccessApi: state.Jobs.createRecurringJobSuccess,
  }));

  useEffect(() => {
    if (isEmpty(createRecurringJobSuccessApi)) return;
    if (createRecurringJobSuccessApi.status === 200) {
      toast.success(createRecurringJobSuccessApi.message);
      if (singleCustomerPageEditCreate) {
        const singleCustomerJobsList = [
          {
            job_data: {
              Customer_Id: singleCustomerPage_Customer_Id,
            },
          },
        ];
        dispatch(getSingleCustomerJobsList(singleCustomerJobsList));
      }
      setModal(false);
      dispatch(getJobsData());
      setJobCreateEdit(initialJobCreateEdit);
      // if (createAndViewJob) {
      //   history.push(`/single-job/${createRecurringJobSuccessApi.Job_Id}`);
      // }
    } else {
      toast.error(createRecurringJobSuccessApi.message);
    }
    setCreateAndViewJob(false);
    dispatch(createRecurringJobSuccess([]));
  }, [createRecurringJobSuccessApi]);

  const {
    jobsCreateSuccessApi,
    jobsCreateSuccessLoading,
    jobUpdateSuccessLoading,
    recurringJobCreateSuccessLoading,
  } = useSelector((state) => ({
    jobsCreateSuccessApi: state.Jobs.jobsCreateSuccess,
    jobsCreateSuccessLoading: state.Jobs.jobsCreateSuccessLoading,
    jobUpdateSuccessLoading: state.Jobs.jobUpdateSuccessLoading,
    recurringJobCreateSuccessLoading:
      state.Jobs.recurringJobCreateSuccessLoading,
  }));

  useEffect(() => {
    if (isEmpty(jobsCreateSuccessApi)) return;
    if (jobsCreateSuccessApi.status === 200) {
      toast.success(jobsCreateSuccessApi.message);
      // Change #100308 - tags picked while creating go on the new job.
      if (jobsCreateSuccessApi?.Job_Id) syncJobTags(jobsCreateSuccessApi.Job_Id);
      if (singleCustomerPageEditCreate) {
        const singleCustomerJobsList = [
          {
            job_data: {
              Customer_Id: singleCustomerPage_Customer_Id,
            },
          },
        ];
        dispatch(getSingleCustomerJobsList(singleCustomerJobsList));
      }
      setModal(false);
      dispatch(getJobsData());

      // Change #100256 - the timer, exactly as the task popup does it:
      //   nothing running -> put the new job on the entry and flip
      //                      timerIsRunning (TimeTrackingDropdown opens the
      //                      entry server side);
      //   already running -> move the running entry onto the new job and raise
      //                      actionEventFired (which saves the open entry) -
      //                      never restart it, which would close the entry and
      //                      lose the time already on it.
      if (startTimerOnSave && jobsCreateSuccessApi?.Job_Id) {
        const jobTitle = jobCreateEdit?.Title || "";
        dispatch(
          timeEntryReduxStateDataSuccess({
            timeentry_data: {
              ...(timerEntryData || {}),
              Job_Id: jobsCreateSuccessApi.Job_Id,
              Job_Title: jobTitle,
              // A new job has no tasks yet; a task left on the entry from
              // before would belong to some other job.
              Task_Id: "",
              BillableType: "1",
              activeTab: "1",
            },
          })
        );
        if (timerRunning) {
          dispatch(actionEventFiredSuccess(true));
          toast.success(`Timer assigned to "${jobTitle}"`);
        } else {
          dispatch(timerIsRunning(true));
          toast.success(`Timer started on "${jobTitle}"`);
        }
      }
      setStartTimerOnSave(false);

      // Let a caller (e.g. "Create & Link Job" on a task) grab the new job id
      // so it can link it, instead of navigating to the job.
      if (onJobCreated && jobsCreateSuccessApi?.Job_Id) {
        // Second arg (the create form) is optional context for callers that
        // want to show the new job straight away, e.g. the timer pop-out
        // (Task 24840). Existing callers take only the id and ignore it.
        onJobCreated(jobsCreateSuccessApi.Job_Id, jobCreateEdit);
      } else if (createAndViewJob) {
        history.push(`/single-job/${jobsCreateSuccessApi.Job_Id}`);
      }
      setJobCreateEdit(initialJobCreateEdit);
    } else {
      toast.error(jobsCreateSuccessApi.message);
    }
    setCreateAndViewJob(false);
    dispatch(addJobSuccess([]));
  }, [jobsCreateSuccessApi]);

  // Handle Update Job
  const handleUpdateJob = () => {
    //Check if title is not empty if it is toast error
    if (jobCreateEdit.Title === "") {
      toast.error("Please enter job title");
      return;
    }
    if (jobCreateEdit.JobStatus_Id === "") {
      toast.error("Please select job status");
      return;
    }

    jobCreateEdit.isRecurring
      ? dispatch(updateRecurringJob([jobCreateEdit]))
      : dispatch(onUpdateJob([jobCreateEdit]));
    setLocalJobUpdate(true);
  };

  const { jobUpdateSuccessAPI } = useSelector((state) => ({
    jobUpdateSuccessAPI: state.Jobs.jobUpdateSuccess,
  }));
  const { updateRecurringJobSuccessAPI, updateRecurringJobSuccessLoading } =
    useSelector((state) => ({
      updateRecurringJobSuccessAPI: state.Jobs.updateRecurringJobSuccess,
      updateRecurringJobSuccessLoading:
        state.Jobs.updateRecurringJobSuccessLoading,
    }));
  useEffect(() => {
    if (isEmpty(jobUpdateSuccessAPI)) return;
    if (!localJobUpdate) return;
    if (jobUpdateSuccessAPI.status === 200) {
      toast.success(jobUpdateSuccessAPI.message);
      // Change #100308 - the tags picked in the popup.
      syncJobTags(jobCreateEdit?.Id || singleJobEditData?.Id);
      if (singleCustomerPageEditCreate) {
        const singleCustomerJobsList = [
          {
            job_data: {
              Customer_Id: singleCustomerPage_Customer_Id,
            },
          },
        ];
        dispatch(getSingleCustomerJobsList(singleCustomerJobsList));
      }
      // jobCreateEdit.isRecurring
      //   ? dispatch(getRecurringJobsList())
      //   : dispatch(getJobsData());
      dispatch(getRecurringJobsList());
      dispatch(getJobsData());
      dispatch(getUninvoicedJobsList());
      if (singleJobPage) {
        dispatch(dispatch(readSingleJob({ id: singleJobEditData?.Id })));
      }
      setJobCreateEdit(initialJobCreateEdit);
      setModal(false);
    } else {
      toast.error(jobUpdateSuccessAPI.message);
    }
    dispatch(updateJobSuccess([]));
    setLocalJobUpdate(false);
  }, [jobUpdateSuccessAPI]);

  useEffect(() => {
    if (isEmpty(updateRecurringJobSuccessAPI)) return;
    if (!localJobUpdate) return;
    if (updateRecurringJobSuccessAPI.status === 200) {
      toast.success(updateRecurringJobSuccessAPI.message);
      if (singleCustomerPageEditCreate) {
        const singleCustomerJobsList = [
          {
            job_data: {
              Customer_Id: singleCustomerPage_Customer_Id,
            },
          },
        ];
        dispatch(getSingleCustomerJobsList(singleCustomerJobsList));
      }
      jobCreateEdit.isRecurring
        ? dispatch(getRecurringJobsList())
        : dispatch(getJobsData());

      setJobCreateEdit(initialJobCreateEdit);
      setModal(false);
    } else {
      toast.error(updateRecurringJobSuccessAPI.message);
    }
    dispatch(updateRecurringJobSuccess([]));
    setLocalJobUpdate(false);
  }, [updateRecurringJobSuccessAPI]);

  const [activeVerticalTab, setActiveVerticalTab] = useState(1);
  function toggleVerticalTab(tab) {
    if (activeVerticalTab !== tab) {
      setActiveVerticalTab(tab);
    }
  }

  // Build a CRMit file-attachment object from a File/Blob + base64 string
  const buildFileObject = (file, base64String) => ({
    FileName: file.name,
    Name: file.name,
    Description: "",
    FileType: file.type,
    FileLastModifiedDateTime:
      // lastModified :  1688025899146 convert to date using moment format: 2021-07-27 10:44:59
      moment(file.lastModified || Date.now()).format("YYYY-MM-DD HH:mm:ss"),
    FileSizeBytes: file.size,
    FileBase64: base64String,
    collapse: true,
  });

  // Append one or more files (from file picker, clipboard button, or Ctrl+V)
  const appendFiles = (files) => {
    files.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setJobCreateEdit((prevState) => ({
          ...prevState,
          fileattachment_list: [
            ...(prevState.fileattachment_list || []),
            buildFileObject(file, reader.result),
          ],
        }));
      };
    });
  };

  const handleMultipleFiles = (e) => {
    // receive files from input convert to base 64 and append to state
    const filesArr = Array.prototype.slice.call(e.target.files);
    if (!filesArr.length) return;
    appendFiles(filesArr);
    // reset so the same file can be re-selected
    e.target.value = "";
  };

  const handleRemoveAttachment = (index) => {
    setJobCreateEdit((prevState) => ({
      ...prevState,
      fileattachment_list: (prevState.fileattachment_list || []).filter(
        (_, i) => i !== index
      ),
    }));
  };

  // Read an image from the clipboard via the async Clipboard API (button click)
  const handlePasteFromClipboard = async () => {
    try {
      if (!navigator.clipboard || !navigator.clipboard.read) {
        toast.error(
          "Clipboard access isn't supported here. Try Ctrl+V instead."
        );
        return;
      }
      const items = await navigator.clipboard.read();
      const imageFiles = [];
      for (const item of items) {
        const imageType = item.types.find((t) => t.startsWith("image/"));
        if (!imageType) continue;
        const blob = await item.getType(imageType);
        const ext = imageType.split("/")[1] || "png";
        const fileName = `pasted-image-${moment().format(
          "YYYYMMDD-HHmmss"
        )}-${imageFiles.length + 1}.${ext}`;
        imageFiles.push(
          new File([blob], fileName, { type: imageType, lastModified: Date.now() })
        );
      }
      if (isEmpty(imageFiles)) {
        toast.error("No image found in clipboard. Copy an image first.");
        return;
      }
      appendFiles(imageFiles);
      toast.success(
        `${imageFiles.length} image${
          imageFiles.length > 1 ? "s" : ""
        } added from clipboard`
      );
    } catch (err) {
      toast.error(
        "Couldn't read the clipboard. Allow clipboard permission, or use Ctrl+V."
      );
    }
  };

  // Ctrl+V anywhere in the open modal pastes an image straight into the list
  useEffect(() => {
    if (!modal) return;
    const onPaste = (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;
      const files = [];
      for (const it of items) {
        if (it.kind === "file" && it.type.startsWith("image/")) {
          const blob = it.getAsFile();
          if (!blob) continue;
          const ext = it.type.split("/")[1] || "png";
          const named =
            blob.name && blob.name !== "image.png"
              ? blob
              : new File(
                  [blob],
                  `pasted-image-${moment().format("YYYYMMDD-HHmmss")}.${ext}`,
                  { type: it.type, lastModified: Date.now() }
                );
          files.push(named);
        }
      }
      if (files.length) {
        appendFiles(files);
        toast.success(
          `${files.length} image${files.length > 1 ? "s" : ""} pasted`
        );
      }
    };
    document.addEventListener("paste", onPaste);
    return () => document.removeEventListener("paste", onPaste);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modal]);

  // Shared upload UI: file picker + paste button + thumbnail preview/remove list
  const renderUploadSection = () => (
    <div className={"pt-2"}>
      <Label className="form-label">Upload Multiple Files</Label>
      <div className="d-flex gap-2 align-items-center">
        <Input
          type="file"
          className="form-control"
          id="multipleFiles"
          multiple
          onChange={(e) => {
            handleMultipleFiles(e);
          }}
        />
        <button
          type="button"
          className="btn btn-soft-primary btn-sm d-flex align-items-center text-nowrap"
          onClick={handlePasteFromClipboard}
          title="Paste an image copied to your clipboard (or press Ctrl+V)"
        >
          <i className="fa-solid fa-clipboard me-1"></i> Paste
        </button>
      </div>
      {!isEmpty(jobCreateEdit?.fileattachment_list) && (
        <div className="d-flex flex-wrap gap-2 mt-2">
          {jobCreateEdit.fileattachment_list.map((file, index) => (
            <div
              key={index}
              className="border rounded p-1 d-flex align-items-center"
              style={{ maxWidth: 180 }}
            >
              {file?.FileType?.startsWith("image/") && file?.FileBase64 ? (
                <img
                  src={file.FileBase64}
                  alt={file.FileName}
                  className="rounded me-2"
                  style={{ width: 40, height: 40, objectFit: "cover" }}
                />
              ) : (
                <i className="fa-solid fa-file fs-4 me-2"></i>
              )}
              <span
                className="text-truncate"
                style={{ maxWidth: 90 }}
                title={file.FileName}
              >
                {file.FileName}
              </span>
              <span
                className="btn btn-sm text-danger p-0 ms-1"
                title="Remove"
                onClick={() => handleRemoveAttachment(index)}
              >
                <i className="fa-solid fa-xmark"></i>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );

  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(singleJobEditData)) return;

    setJobCreateEdit({
      Id: singleJobEditData?.Id,
      Title: singleJobEditData?.Title,
      Description: singleJobEditData?.Description,
      Customer_Id: singleJobEditData?.Customer_Id,
      BillToCustomer_Id: singleJobEditData?.BillToCustomer_Id ?? "",
      CustomerSiteLocation_Id: singleJobEditData?.CustomerSiteLocation_Id,
      // Change #100005: the API sends the flag as the string "0", which is
      // truthy, so every edit opened with Manual Address switched on.
      FlagUseManualAddress:
        Number(singleJobEditData?.FlagUseManualAddress) === 1 ? 1 : 0,
      AddressLine1: singleJobEditData?.AddressLine1 ?? "",
      AddressLine2: singleJobEditData?.AddressLine2 ?? "",
      AddressLine3: singleJobEditData?.AddressLine3 ?? "",
      AddressLine4: singleJobEditData?.AddressLine4 ?? "",
      AddressCity: singleJobEditData?.AddressCity ?? "",
      AddressCounty: singleJobEditData?.AddressCounty ?? "",
      AddressPostCode: singleJobEditData?.AddressPostCode ?? "",
      AddressCountry: singleJobEditData?.AddressCountry ?? "",
      Staff_Id: singleJobEditData?.Staff_Id,
      JobStatus_Id: singleJobEditData?.JobStatus_Id,
      JobPriority_Id: singleJobEditData?.JobPriority_Id,
      JobType_Id: singleJobEditData?.JobType_Id,
      ContractItem_Id: singleJobEditData?.ContractItem_Id,
      RecurringStartDateTime: singleJobEditData?.RecurringStartDateTime,
      RecurringEndDateTime: singleJobEditData?.RecurringEndDateTime,
      RecurringNextDateTime: singleJobEditData?.RecurringNextDateTime,
      UnitFrequency_Id: singleJobEditData?.UnitFrequency_Id,
      isRecurring: recurringJob,
      fileattachment_list: singleJobEditData?.fileattachment_list,
      emailinbound_list: singleJobEditData?.emailinbound_list,
      Vehicle_Id: singleJobEditData?.Vehicle_Id,
      CustomerReference: singleJobEditData?.CustomerReference,
      InvoiceSummaryText: singleJobEditData?.InvoiceSummaryText,
      CompletedDateTime: singleJobEditData?.CompletedDateTime,
    });
  }, [singleJobEditData]);

  const [activeTab, setActiveTab] = useState("job");
  const [modalVehicle, setModalVehicle] = useState(false);
  const toggleVehicle = () => setModalVehicle(!modalVehicle);

  // Change #100404 - add a customer on the fly from the Select Customer picker.
  // CreateEditCustomer's onCustomerCreated mode (Change #100150) creates it
  // without navigating away and hands the new customer back to be selected, so
  // nothing typed into the job is lost. The label is kept until the reloaded
  // customer list includes the new customer.
  const [modalCreateCustomer, setModalCreateCustomer] = useState(false);
  const [newCustomerLabel, setNewCustomerLabel] = useState(null);

  // Change #100425 - add a site location on the fly, the same way. The popup
  // reloads this customer's site locations itself (fromCustomerPage) and hands
  // back the new Id, which is selected on the job.
  const [modalCreateSiteLocation, setModalCreateSiteLocation] = useState(false);
  const handleSiteLocationCreated = (siteLocationId) => {
    if (!siteLocationId) return;
    setJobCreateEdit((prev) => ({
      ...prev,
      CustomerSiteLocation_Id: String(siteLocationId),
    }));
  };
  const handleCustomerCreated = (customerData, details) => {
    const id = customerData?.Id;
    if (!id) return;
    setNewCustomerLabel({
      id: String(id),
      label:
        (details?.CustomerBusinessType_Id === "1"
          ? details?.BusinessName
          : [details?.PersonFirstName, details?.PersonLastName]
              .filter(Boolean)
              .join(" ")) || "",
    });
    // Customer_Id is checked with lodash isEmpty, which treats numbers as empty.
    setJobCreateEdit((prev) => ({ ...prev, Customer_Id: String(id) }));
  };
  const [continueOrCancelModal, setContinueOrCancelModal] = useState(false);
  const toggleContinueOrCancel = () => {
    setContinueOrCancelModal(!continueOrCancelModal);
  };

  // Shared by the Customer and Bill To (payer) pickers.
  const customerSelectOptions = !isEmpty(customersList)
    ? customersList?.map((item) => ({
        firstLine: {
          label: "#" + item?.Id + " " + item?.FullName,
        },
        secondLine: {
          label: item?.AddressLine1
            ? item?.AddressLine1
            : "" + " " + item?.AddressCity
            ? item?.AddressCity
            : "" + " " + item?.AddressPostCode
            ? item?.AddressPostCode
            : "",
        },
        thirdLine: {
          label:
            !isEmpty(item?.contactemailaddress_list) &&
            item?.contactemailaddress_list
              ?.map((email) => email?.ContactEmailAddress_EmailAddress)
              .join(", "),
        },
        forthLine: {
          label:
            !isEmpty(item?.contacttelephonenumber_list) &&
            item?.contacttelephonenumber_list
              ?.map((phone) => phone?.ContactTelephoneNumber_TelephoneNumber)
              .join(", "),
        },
        value: item?.Id,
        id: item?.Id,
        item,
      }))
    : [];

  const savingJob =
    recurringJobCreateSuccessLoading ||
    jobsCreateSuccessLoading ||
    updateRecurringJobSuccessLoading ||
    jobUpdateSuccessLoading;
  const showJobFooter =
    (jobCreateEdit.isRecurring && activeVerticalTab === 3) ||
    !jobCreateEdit.isRecurring;

  return (
    <>
      {continueOrCancelModal && (
        <ContinueOrCancel
          title={"This Customer has an open contract?"}
          paragraph={"Do you want to continue or cancel?"}
          modal={continueOrCancelModal}
          toggle={toggleContinueOrCancel}
          onClickCallBack={() => {
            setContinueWithCreatingNewJob(true);
            !isEdit && handleCreateJob(true);
            toggleContinueOrCancel();
          }}
        />
      )}
      {modalCreateCustomer && (
        <CreateEditCustomer
          modalCreateCustomer={modalCreateCustomer}
          setModalCreateCustomer={setModalCreateCustomer}
          toggleCreateCustomer={() => setModalCreateCustomer(false)}
          onCustomerCreated={handleCustomerCreated}
        />
      )}
      {modalCreateSiteLocation && jobCreateEdit?.Customer_Id && (
        <CreateEditCustomerSiteLocation
          modal={modalCreateSiteLocation}
          setModal={setModalCreateSiteLocation}
          toggle={() => setModalCreateSiteLocation(false)}
          setIsEdit={() => {}}
          isEdit={false}
          fromCustomerPage={true}
          Customer_Id={jobCreateEdit.Customer_Id}
          onCreated={handleSiteLocationCreated}
        />
      )}
      {modalVehicle && (
        <CreateEditVehicle
          modal={modalVehicle}
          toggle={toggleVehicle}
          isEdit={false}
        />
      )}
      <AppModal
        open={modal}
        onClose={toggle}
        title={
          isEdit && !cloneJob
            ? "Job Update # " + jobCreateEdit.Id
            : cloneJob
            ? "Clone Job #" + jobCreateEdit.Id
            : "Create New Job"
        }
        icon={<WorkOutlineOutlinedIcon />}
        headerAccent="indigo"
        size={jobCreateEdit.isRecurring ? "lg" : "md"}
        loading={savingJob}
        loadingText="Saving job…"
        hideFooter={!showJobFooter}
        footer={
          <div className="hstack gap-2 justify-content-end">
            {/* Change #100256 - the label says which of the two will happen. */}
            {(!isEdit || cloneJob) && !jobCreateEdit?.isRecurring && (
              <Button
                color="inherit"
                onClick={() => setStartTimerOnSave((v) => !v)}
                title={
                  timerRunning
                    ? "Your running timer will be moved onto this job when it is created. The time already on it is kept."
                    : "Start the timer on this job as soon as it is created"
                }
                sx={{ textTransform: "none" }}
              >
                <input
                  className="me-2"
                  type="checkbox"
                  checked={startTimerOnSave}
                  readOnly
                />
                {timerRunning ? "Assign timer" : "Start timer"}
              </Button>
            )}
            <Button
              color="inherit"
              variant="outlined"
              onClick={() => {
                setModal(false);
              }}
              disabled={savingJob}
            >
              Close
            </Button>
            {isEdit && !cloneJob && (
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  handleUpdateJob();
                }}
                disabled={savingJob}
              >
                Update
              </Button>
            )}
            {!isEdit && (
              <UncontrolledDropdown>
                <span
                  className="btn btn-success shape-border-prefix-button-style"
                  id="add-btn"
                  onClick={() => {
                    handleCreateJob();
                    setCreateAndViewJob(true);
                  }}
                >
                  {" "}
                  Create & View
                </span>
                <DropdownToggle
                  className={"btn-success shape-border-suffix-button-style"}
                >
                  <span className="icon icon-sm">
                    {" "}
                    <i className="fa fa-caret-down"></i>
                  </span>
                </DropdownToggle>
                <DropdownMenu
                  container="body"
                  style={{ zIndex: "var(--z-app-menu, 1350)" }}
                >
                  <DropdownItem
                    onClick={() => {
                      handleCreateJob();
                    }}
                  >
                    Create Only
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleCreateJob();
                      setCreateAndViewJob(true);
                    }}
                  >
                    Create & View
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
            {isEdit && cloneJob && (
              <UncontrolledDropdown>
                <span
                  className="btn btn-success shape-border-prefix-button-style"
                  id="add-btn"
                  onClick={() => {
                    handleCreateJob();
                    setCreateAndViewJob(true);
                  }}
                >
                  {" "}
                  Create & View
                </span>
                <DropdownToggle
                  className={"btn-success shape-border-suffix-button-style"}
                >
                  <span className="icon icon-sm">
                    {" "}
                    <i className="fa fa-caret-down"></i>
                  </span>
                </DropdownToggle>
                <DropdownMenu
                  container="body"
                  style={{ zIndex: "var(--z-app-menu, 1350)" }}
                >
                  <DropdownItem
                    onClick={() => {
                      handleCreateJob();
                    }}
                  >
                    Create Only
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleCreateJob();
                      setCreateAndViewJob(true);
                    }}
                  >
                    Create & View
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            )}
          </div>
        }
      >
        <div className="d-flex flex-row justify-content-end align-items-center mb-2">
          <span className={"pe-2"}>Recurring</span>

          <div className={"mt-1"}>
            <label className="switch-create-job">
              {" "}
              <input
                className={"input-create-job"}
                type="checkbox"
                checked={jobCreateEdit?.isRecurring}
                onChange={(e) => {
                  setJobCreateEdit({
                    ...jobCreateEdit,
                    isRecurring: e.target.checked,
                  });
                }}
              />
              <span className="slider-create-job round-create-job"></span>
            </label>
          </div>
        </div>

        {!jobCreateEdit?.isRecurring && (
          <>
            {!isEdit && (
              <div>
                <div id="mail-filter-navlist">
                  <Nav
                    className="nav nav-tabs nav-tabs-custom nav-primary gap-1 text-center border-bottom-0"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "job" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          setActiveTab("job");
                        }}
                        href="#"
                      >
                        <i className="fa-regular fa-folder-open"></i>
                        <span className="ms-1 d-none d-sm-inline-block">
                          Job
                        </span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames(
                          { active: activeTab === "task" },
                          "fw-semibold"
                        )}
                        onClick={() => {
                          setActiveTab("task");
                        }}
                        href="#"
                      >
                        <i className="fa-solid fa-folder-tree"></i>
                        <span className="ms-1 d-none d-sm-inline-block">
                          Task
                        </span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </div>
            )}

            {activeTab === "job" && (
              <div className={"mt-2"}>
                <Input type="hidden" id="id-field" />
                <Row className="g-3">
                  <Col lg={12}>
                    <div>
                      <Label htmlFor="name-field" className="form-label">
                        Job Title<span className={"text-danger"}>*</span>
                      </Label>

                      <Input
                        name="Title"
                        id="Title"
                        className="form-control"
                        placeholder={
                          isEdit ? jobCreateEdit?.Title : `Create Job Title`
                        }
                        type="text"
                        onChange={(e) => {
                          setJobCreateEdit({
                            ...jobCreateEdit,
                            Title: e.target.value,
                          });
                        }}
                        value={jobCreateEdit?.Title}
                      />
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div>
                      <Label
                        htmlFor="company_name-field"
                        className="form-label"
                      >
                        Job Description
                      </Label>

                      <RichTextEditor
                        autoFocus={page === "singleEmailInbound"}
                        initialValue={jobCreateEdit.Description}
                        placeholder={
                          isEdit
                            ? jobCreateEdit.Description
                            : `Create Job Description`
                        }
                        handleContentChange={(e) => {
                          setJobCreateEdit({
                            ...jobCreateEdit,
                            Description: e,
                          });
                        }}
                        receivedContent={
                          jobCreateEdit.Id
                            ? singleJobEditData?.Description
                            : null
                        }
                        isClearEditor={isClearEditor}
                        setIsClearEditor={setIsClearEditor}
                      />
                    </div>
                  </Col>
                  <Col lg={12}>
                    <Label>Invoice Summary Text</Label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={
                        isEdit
                          ? jobCreateEdit?.InvoiceSummaryText
                          : `Create Invoice Summary Text`
                      }
                      onChange={(e) => {
                        setJobCreateEdit({
                          ...jobCreateEdit,
                          InvoiceSummaryText: e.target.value,
                        });
                      }}
                      value={jobCreateEdit?.InvoiceSummaryText}
                    />
                  </Col>

                  <Col lg={12}>
                    <div>
                      <Label
                        htmlFor="company_name-field"
                        className="form-label"
                      >
                        Select Customer<span className={"text-danger"}>*</span>
                      </Label>
                      <div>
                        <CustomSelect
                          value={jobCreateEdit.Customer_Id}
                          placeholder={
                            !isEmpty(jobCreateEdit.Customer_Id)
                              ? "#" +
                                jobCreateEdit.Customer_Id +
                                " " +
                                (customersList?.find(
                                  (job) => job.Id === jobCreateEdit.Customer_Id
                                )?.FullName
                                  ? customersList?.find(
                                      (job) =>
                                        job.Id === jobCreateEdit.Customer_Id
                                    )?.FullName + " "
                                  : newCustomerLabel?.id ===
                                    String(jobCreateEdit.Customer_Id)
                                  ? newCustomerLabel.label
                                  : "")
                              : "Select..."
                          }
                          onClickCallBack={(e) => {
                            if (!e) {
                              setJobCreateEdit({
                                ...jobCreateEdit,
                                Customer_Id: null,
                              });
                              return;
                            }
                            setJobCreateEdit({
                              ...jobCreateEdit,
                              Customer_Id: e.value,
                            });
                          }}
                          options={customerSelectOptions}
                          addNewItem={true}
                          addNewItemCallBack={() =>
                            setModalCreateCustomer(true)
                          }
                        />
                      </div>
                    </div>
                  </Col>
                  {/* Change #100371 - the payer, when it is not the customer above
                      (e.g. an insurer paying for a policyholder). Invoices and
                      proformas from this job go to this customer and use their
                      pricing. On a recurring job it is copied onto every job the
                      schedule generates (Change #100372). */}
                  {jobCreateEdit?.Customer_Id && (
                    <Col lg={12}>
                      <div>
                        <Label className="form-label">Bill To (payer)</Label>
                        <CustomSelect
                          value={jobCreateEdit.BillToCustomer_Id}
                          placeholder={
                            !isEmpty(jobCreateEdit.BillToCustomer_Id)
                              ? "#" +
                                jobCreateEdit.BillToCustomer_Id +
                                " " +
                                (customersList?.find(
                                  (customer) =>
                                    customer.Id ===
                                    jobCreateEdit.BillToCustomer_Id
                                )?.FullName ??
                                  singleJobEditData?.BillToCustomer_FullName ??
                                  "")
                              : "Same as customer"
                          }
                          onClickCallBack={(e) => {
                            setJobCreateEdit({
                              ...jobCreateEdit,
                              BillToCustomer_Id:
                                e && e.value !== jobCreateEdit.Customer_Id
                                  ? e.value
                                  : "",
                            });
                          }}
                          options={customerSelectOptions}
                        />
                        <small className="text-muted">
                          Leave blank when the customer pays their own invoices.
                        </small>
                      </div>
                    </Col>
                  )}
                  {jobCreateEdit?.Customer_Id && (
                    <Col lg={12}>
                      <div>
                        <Label
                          htmlFor="company_name-field"
                          className="form-label"
                        >
                          Customer Reference
                        </Label>
                        <Input
                          name="CustomerReference"
                          id="CustomerReference"
                          className="form-control"
                          placeholder={
                            isEdit
                              ? jobCreateEdit?.CustomerReference
                              : `Create Customer Reference`
                          }
                          type="text"
                          onChange={(e) => {
                            setJobCreateEdit({
                              ...jobCreateEdit,
                              CustomerReference: e.target.value,
                            });
                          }}
                          value={jobCreateEdit?.CustomerReference}
                        />
                      </div>
                    </Col>
                  )}

                  {jobCreateEdit.Customer_Id && !isEmpty(PeopleList) && (
                    <Col lg={12}>
                      <div>
                        <Label
                          htmlFor="company_name-field"
                          className="form-label"
                        >
                          People
                        </Label>
                        <div>
                          <Select
                            className="mb-0 job-select2"
                            value={
                              jobCreateEdit.Person_Id
                                ? {
                                    label: PeopleList?.find(
                                      (item) =>
                                        item.Id === jobCreateEdit.Person_Id
                                    )?.FullName,
                                    value: jobCreateEdit.Person_Id,
                                    id: jobCreateEdit.Person_Id,
                                  }
                                : []
                            }
                            onChange={(e) => {
                              setJobCreateEdit({
                                ...jobCreateEdit,
                                Person_Id: e.value,
                              });
                            }}
                            options={
                              !isEmpty(PeopleList)
                                ? PeopleList?.map((item) => ({
                                    label: item.FullName,
                                    value: item.Id,
                                    id: item.Id,
                                  }))
                                : []
                            }
                            id="country-select"
                          ></Select>
                        </div>
                      </div>
                    </Col>
                  )}
                  {/* Change #100476 - one "Job address" choice instead of a
                      Site Location / Manual Address switch. */}
                  {jobCreateEdit?.Customer_Id && (
                    <Col lg={12}>
                      <Label className="form-label">Job address</Label>
                      <div className="btn-group w-100 mb-2" role="group">
                        {[
                          { key: "customer", label: "Customer's address", icon: "ri-user-location-line" },
                          { key: "site", label: "A site location", icon: "ri-building-line" },
                          { key: "manual", label: "Another address", icon: "ri-edit-line" },
                        ].map((opt) => (
                          <button
                            key={opt.key}
                            type="button"
                            className={
                              "btn btn-sm " +
                              (jobAddressMode === opt.key ? "btn-primary" : "btn-outline-primary")
                            }
                            onClick={() => applyJobAddressMode(opt.key)}
                          >
                            <i className={`${opt.icon} align-bottom me-1`}></i>
                            {opt.label}
                          </button>
                        ))}
                      </div>
                      {jobAddressMode === "customer" && (
                        <div className="alert alert-light border py-2 px-3 mb-2 small">
                          <i className="ri-map-pin-line align-bottom me-1"></i>
                          {addressText(customerAddress) ? (
                            <>
                              This job will go to <strong>{addressText(customerAddress)}</strong>
                            </>
                          ) : (
                            <span className="text-danger">
                              This customer has no address on file. Pick a site location or type
                              another address.
                            </span>
                          )}
                        </div>
                      )}
                    </Col>
                  )}
                  {jobCreateEdit?.Customer_Id &&
                    jobAddressMode === "site" && (
                    <Col lg={12}>
                      <div>
                        <div className="d-flex align-items-center justify-content-between">
                          <Label
                            htmlFor="company_name-field"
                            className="form-label"
                          >
                            Site Location
                          </Label>
                          {/* Change #100425 */}
                          <button
                            type="button"
                            className="btn btn-sm btn-link p-0 mb-2"
                            onClick={() => setModalCreateSiteLocation(true)}
                            title="Create a new site location for this customer and select it"
                          >
                            <i className="ri-add-line align-bottom me-1"></i>
                            New site location
                          </button>
                        </div>
                        <div>
                          <CustomSelect
                            style={{ maxWidth: "770px" }}
                            value={jobCreateEdit?.CustomerSiteLocation_Id}
                            placeholder={
                              jobCreateEdit?.CustomerSiteLocation_Id
                                ? "#" +
                                  jobCreateEdit?.CustomerSiteLocation_Id +
                                  (singleCustomerSiteLocationListAPI?.find(
                                    (item) =>
                                      item.Id ===
                                      jobCreateEdit.CustomerSiteLocation_Id
                                  )?.FullName
                                    ? " " +
                                      singleCustomerSiteLocationListAPI?.find(
                                        (item) =>
                                          item.Id ===
                                          jobCreateEdit.CustomerSiteLocation_Id
                                      )?.FullName
                                    : "")
                                : "Select..."
                            }
                            onClickCallBack={(e) => {
                              if (!e) {
                                setJobCreateEdit({
                                  ...jobCreateEdit,
                                  CustomerSiteLocation_Id: null,
                                });
                                return;
                              }
                              setJobCreateEdit({
                                ...jobCreateEdit,
                                CustomerSiteLocation_Id: e?.value,
                              });
                            }}
                            options={
                              !isEmpty(singleCustomerSiteLocationListAPI)
                                ? singleCustomerSiteLocationListAPI?.map(
                                    (item) => ({
                                      firstLine: {
                                        label:
                                          "#" +
                                          item?.Id +
                                          " " +
                                          item?.FullName +
                                          (item?.SiteReference
                                            ? " " + item?.SiteReference
                                            : ""),
                                      },
                                      secondLine: {
                                        label:
                                          (item?.AddressLine1
                                            ? item?.AddressLine1
                                            : "") +
                                          (item?.AddressLine2
                                            ? " " + item?.AddressLine2
                                            : "") +
                                          (item?.AddressLine3
                                            ? " " + item?.AddressLine3
                                            : "") +
                                          (item?.AddressLine4
                                            ? " " + item?.AddressLine4
                                            : "") +
                                          (item?.AddressCity
                                            ? " " + item?.AddressCity
                                            : "") +
                                          (item?.AddressCounty
                                            ? " " + item?.AddressCounty
                                            : "") +
                                          (item?.AddressPostCode
                                            ? " " + item?.AddressPostCode
                                            : "") +
                                          (item?.AddressCountry
                                            ? " " + item?.AddressCountry
                                            : ""),
                                      },
                                      value: item?.Id,
                                      id: item?.Id,
                                      item,
                                    })
                                  )
                                : []
                            }
                          />
                        </div>
                        {/* Change #100476 - say where the job is going. */}
                        {(() => {
                          const site = (singleCustomerSiteLocationListAPI || []).find(
                            (s) => String(s.Id) === String(jobCreateEdit?.CustomerSiteLocation_Id)
                          );
                          return (
                            <div className="alert alert-light border py-2 px-3 mt-2 mb-2 small">
                              <i className="ri-map-pin-line align-bottom me-1"></i>
                              {!jobCreateEdit?.CustomerSiteLocation_Id ? (
                                <span className="text-danger">
                                  No site picked yet. Until one is, the job uses the customer's
                                  address.
                                </span>
                              ) : addressText(site) ? (
                                <>
                                  This job will go to <strong>{addressText(site)}</strong>
                                </>
                              ) : (
                                <span className="text-muted">This site has no address on file.</span>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    </Col>
                  )}
                  {jobCreateEdit?.Customer_Id &&
                    !!jobCreateEdit?.FlagUseManualAddress && (
                    <Col lg={12}>
                      <div className="row">
                        {[
                          { key: "AddressLine1", label: "Address Line 1", col: 12 },
                          { key: "AddressLine2", label: "Address Line 2", col: 12 },
                          { key: "AddressLine3", label: "Address Line 3", col: 6 },
                          { key: "AddressLine4", label: "Address Line 4", col: 6 },
                          { key: "AddressCity", label: "City", col: 6 },
                          { key: "AddressCounty", label: "County", col: 6 },
                          { key: "AddressPostCode", label: "Post Code", col: 6 },
                          { key: "AddressCountry", label: "Country", col: 6 },
                        ].map((field) => (
                          <div className={`col-lg-${field.col} mb-2`} key={field.key}>
                            <Label
                              htmlFor={field.key}
                              className="form-label"
                            >
                              {field.label}
                            </Label>
                            <Input
                              name={field.key}
                              id={field.key}
                              className="form-control"
                              type="text"
                              value={jobCreateEdit?.[field.key] ?? ""}
                              onChange={(e) => {
                                setJobCreateEdit({
                                  ...jobCreateEdit,
                                  [field.key]: e.target.value,
                                });
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </Col>
                  )}
                  <Col lg={12}>
                    <div>
                      <Label
                        htmlFor="company_name-field"
                        className="form-label"
                      >
                        Staff
                      </Label>
                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={
                            jobCreateEdit.Staff_Id
                              ? {
                                  label:
                                    staffData?.find(
                                      (item) =>
                                        item.Id === jobCreateEdit.Staff_Id
                                    )?.FirstName +
                                    " " +
                                    staffData?.find(
                                      (item) =>
                                        item.Id === jobCreateEdit.Staff_Id
                                    )?.LastName,
                                  value: jobCreateEdit.Staff_Id,
                                  id: jobCreateEdit.Staff_Id,
                                }
                              : []
                          }
                          onChange={(e) => {
                            setJobCreateEdit({
                              ...jobCreateEdit,
                              Staff_Id: e.value,
                            });
                          }}
                          options={
                            !isEmpty(staffData)
                              ? filterActiveStaff(staffData, [
                                  jobCreateEdit.Staff_Id,
                                ])?.map((item) => ({
                                  label: item?.FirstName + " " + item?.LastName,
                                  value: item?.Id,
                                  id: item?.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    </div>
                  </Col>
                  {isSystemModuleActive(
                    SYSTEM_MODULE_CODES.CUSTOMER_VEHICLE
                  ) && (
                  <Col lg={12}>
                    <Label>Select Vehicle</Label>

                    <CustomSelect
                      style={{ maxWidth: "770px" }}
                      value={jobCreateEdit?.CustomerSiteLocation_Id}
                      placeholder={
                        jobCreateEdit?.Vehicle_Id
                          ? "#" +
                            jobCreateEdit?.Vehicle_Id +
                            " " +
                            (vehicleListAPI?.find(
                              (item) => item.Id === jobCreateEdit.Vehicle_Id
                            )?.Title
                              ? " " +
                                vehicleListAPI?.find(
                                  (item) => item.Id === jobCreateEdit.Vehicle_Id
                                )?.Title
                              : "") +
                            (vehicleListAPI?.find(
                              (item) => item.Id === jobCreateEdit.Vehicle_Id
                            )?.RegistrationPlate
                              ? "Reg: " +
                                vehicleListAPI?.find(
                                  (item) => item.Id === jobCreateEdit.Vehicle_Id
                                )?.RegistrationPlate
                              : "") +
                            " " +
                            (vehicleListAPI?.find(
                              (item) => item.Id === jobCreateEdit.Vehicle_Id
                            )?.MinistryId
                              ? "[MinstrId: " +
                                vehicleListAPI?.find(
                                  (item) => item.Id === jobCreateEdit.Vehicle_Id
                                )?.MinistryId +
                                " ]"
                              : "")
                          : "Select..."
                      }
                      onClickCallBack={(e) => {
                        if (!e) {
                          setJobCreateEdit({
                            ...jobCreateEdit,
                            Vehicle_Id: null,
                          });
                          return;
                        }
                        setJobCreateEdit({
                          ...jobCreateEdit,
                          Vehicle_Id: e.value,
                        });
                      }}
                      options={
                        !isEmpty(vehicleListAPI)
                          ? vehicleListAPI?.map((item) => ({
                              firstLine: {
                                label:
                                  "#" +
                                  item?.Id +
                                  //Title
                                  (item?.Title ? " " + item?.Title : "") +
                                  " " +
                                  (item?.RegistrationPlate
                                    ? "Reg: " + item?.RegistrationPlate
                                    : "") +
                                  " " +
                                  (item?.MinistryId
                                    ? "[MinstrId: " + item?.MinistryId + " ]"
                                    : ""),
                              },
                              secondLine: {
                                label:
                                  (item?.Make ? "Make: " + item?.Make : "") +
                                  (item?.Model
                                    ? " Model: " + item?.Model
                                    : "") +
                                  //VehicleType_Name
                                  (item?.VehicleType_Name
                                    ? " Type: " + item?.VehicleType_Name
                                    : "") +
                                  (item?.ModelYear
                                    ? " Year: " + item?.ModelYear
                                    : "") +
                                  (item?.Mileage
                                    ? " Mileage: " + item?.Mileage
                                    : "") +
                                  (item?.MinistryId
                                    ? " MinistryId: " + item?.MinistryId
                                    : ""),
                              },
                              value: item?.Id,
                              id: item?.Id,
                              item,
                            }))
                          : []
                      }
                      addNewItem={true}
                      addNewItemCallBack={() => {
                        toggleVehicle();
                      }}
                    />
                  </Col>
                  )}
                  <Col lg={12}>
                    <div>
                      <Label
                        htmlFor="company_name-field"
                        className="form-label"
                      >
                        Job Status<span className={"text-danger"}>*</span>
                      </Label>

                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={
                            jobCreateEdit?.JobStatus_Id
                              ? {
                                  label: jobStatusList?.find(
                                    (item) =>
                                      item.Id === jobCreateEdit.JobStatus_Id
                                  )?.Name,
                                }
                              : []
                          }
                          onChange={(e) => {
                            setJobCreateEdit({
                              ...jobCreateEdit,
                              JobStatus_Id: e.value,
                            });
                          }}
                          options={
                            !isEmpty(jobStatusList)
                              ? jobStatusList?.map((item) => ({
                                  label: item.Name,
                                  value: item.Id,
                                  id: item.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div>
                      <Label
                        htmlFor="company_name-field"
                        className="form-label"
                      >
                        Job Type
                      </Label>

                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={
                            jobCreateEdit?.JobType_Id
                              ? {
                                  label: jobsTypeList?.find(
                                    (item) =>
                                      item.Id === jobCreateEdit.JobType_Id
                                  )?.Name,
                                  value: jobCreateEdit.JobType_Id,
                                  id: jobCreateEdit.JobType_Id,
                                }
                              : []
                          }
                          onChange={(e) => {
                            setJobCreateEdit({
                              ...jobCreateEdit,
                              JobType_Id: e.value,
                            });
                          }}
                          options={
                            !isEmpty(jobsTypeList)
                              ? jobsTypeList?.map((item) => ({
                                  label: item?.Name,
                                  value: item?.Id,
                                  id: item?.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div>
                      <Label
                        htmlFor="company_name-field"
                        className="form-label"
                      >
                        Job Priority
                      </Label>

                      <div>
                        <Select
                          className="mb-0 job-select2"
                          value={
                            jobCreateEdit?.JobPriority_Id
                              ? {
                                  label: jobPriorityList?.find(
                                    (item) =>
                                      item.Id === jobCreateEdit.JobPriority_Id
                                  )?.Name,
                                  value: jobCreateEdit.JobPriority_Id,
                                  id: jobCreateEdit.JobPriority_Id,
                                }
                              : []
                          }
                          onChange={(e) => {
                            setJobCreateEdit({
                              ...jobCreateEdit,
                              JobPriority_Id: e.value,
                            });
                          }}
                          options={
                            !isEmpty(jobPriorityList)
                              ? jobPriorityList?.map((item) => ({
                                  label: item?.Name,
                                  value: item?.Id,
                                  id: item?.Id,
                                }))
                              : []
                          }
                          id="country-select"
                        ></Select>
                      </div>
                    </div>
                  </Col>
                  {/* Change #100308 - Job Tags. Saved when the job saves. */}
                  {jobTagLibrary.length > 0 && !jobCreateEdit?.isRecurring && (
                    <Col lg={12}>
                      <div>
                        <Label htmlFor="job-tags-field" className="form-label">
                          Tags
                        </Label>
                        <Select
                          inputId="job-tags-field"
                          className="mb-0 job-select2"
                          isMulti
                          placeholder="Select tags…"
                          value={jobTagSelected.map((id) => ({
                            value: id,
                            label:
                              jobTagLibrary.find((t) => String(t.Id) === id)
                                ?.Name || `#${id}`,
                          }))}
                          onChange={(picked) =>
                            setJobTagSelected(
                              (picked || []).map((p) => String(p.value))
                            )
                          }
                          options={jobTagLibrary
                            .filter(
                              (t) =>
                                String(t.FlagActive ?? "1") === "1" ||
                                jobTagSelected.includes(String(t.Id))
                            )
                            .map((t) => ({
                              value: String(t.Id),
                              label: t.Name,
                            }))}
                        />
                      </div>
                    </Col>
                  )}
                  <Col lg={12}>
                    <div>
                      <Label
                        htmlFor="company_name-field"
                        className="form-label"
                      >
                        Contract Item
                      </Label>

                      <div>
                        <CustomSelect
                          value={jobCreateEdit?.ContractItem_Id}
                          placeholder={
                            jobCreateEdit?.ContractItem_Id
                              ? "#" +
                                jobCreateEdit?.ContractItem_Id +
                                " " +
                                (contractItemsList?.find(
                                  (item) =>
                                    item.Id === jobCreateEdit.ContractItem_Id
                                )?.Title
                                  ? contractItemsList?.find(
                                      (item) =>
                                        item.Id ===
                                        jobCreateEdit.ContractItem_Id
                                    )?.Title
                                  : "") +
                                "  " +
                                (contractItemsList?.find(
                                  (item) =>
                                    item.Id === jobCreateEdit.ContractItem_Id
                                )?.Customer_FullName
                                  ? contractItemsList?.find(
                                      (item) =>
                                        item.Id ===
                                        jobCreateEdit.ContractItem_Id
                                    )?.Customer_FullName
                                  : "")
                              : "Select..."
                          }
                          onClickCallBack={(e) => {
                            if (!e) {
                              setJobCreateEdit({
                                ...jobCreateEdit,
                                ContractItem_Id: null,
                              });
                              return;
                            }
                            setJobCreateEdit({
                              ...jobCreateEdit,
                              ContractItem_Id: e?.value,
                            });
                          }}
                          options={
                            !isEmpty(contractItemsList)
                              ? contractItemsList?.map((item) => ({
                                  firstLine: {
                                    label:
                                      "#" +
                                      item?.Id +
                                      " " +
                                      (item?.Title ? item?.Title : "") +
                                      " for " +
                                      (item?.Customer_FullName
                                        ? item?.Customer_FullName
                                        : ""),
                                  },
                                  secondLine: {
                                    label:
                                      "£ " +
                                      (item?.AmountLocalEach
                                        ? item?.AmountLocalEach
                                        : "") +
                                      " " +
                                      (item?.Product_Name
                                        ? item?.Product_Name
                                        : "") +
                                      " " +
                                      (item?.ZContractUnitFrequency_Name
                                        ? item?.ZContractUnitFrequency_Name
                                        : ""),
                                  },
                                  value: item?.Id,
                                  id: item?.Id,
                                  item,
                                }))
                              : []
                          }
                        />
                      </div>
                    </div>
                    {renderUploadSection()}
                    <div className={"pt-2"}>
                      <Label>Completed Date/Time</Label>
                      <AppDateTimePicker
                        value={
                          jobCreateEdit.CompletedDateTime
                            ? moment(
                                jobCreateEdit.CompletedDateTime,
                                "YYYY-MM-DD HH:mm:ss"
                              )
                            : null
                        }
                        onChange={(val) =>
                          setJobCreateEdit({
                            ...jobCreateEdit,
                            // Preserve the existing stored contract: a plain
                            // "YYYY-MM-DD HH:mm:ss" string, or "" when cleared.
                            CompletedDateTime:
                              val && val.isValid()
                                ? timeFormatDateAndTime(val.toDate())
                                : "",
                          })
                        }
                        slotProps={{
                          textField: {
                            placeholder: "Select Completed Date/Time",
                          },
                        }}
                      />
                    </div>
                  </Col>
                  {jobCreateEdit.ContractItem_Id && (
                    <Col lg={12}>
                      <div>
                        <div>
                          <div>
                            <span className={"d-flex"}>
                              <span className={"pe-1"}>
                                Contract Usage Balance:
                              </span>
                              <span className={"pe-1"}>
                                {handleDurationTime(
                                  contractItemsList?.find(
                                    (item) =>
                                      item.Id === jobCreateEdit.ContractItem_Id
                                  )?.UsageBalanceAmountMins
                                )}{" "}
                              </span>
                              <span>
                                {contractItemsList?.find(
                                  (item) =>
                                    item.Id === jobCreateEdit.ContractItem_Id
                                )?.UsageBalanceAmountMins <= 0
                                  ? "Credit"
                                  : "Debit"}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            )}
            {activeTab === "task" && (
              <div className={"mt-2"}>
                <JobTasks
                  jobCreateEdit={jobCreateEdit}
                  setJobCreateEdit={setJobCreateEdit}
                  initialTaskData={initialTaskData}
                />
              </div>
            )}
          </>
        )}
        {jobCreateEdit?.isRecurring && (
          <>
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody className="form-steps">
                    <form className="vertical-navs-step">
                      <Row className="gy-5">
                        <Col lg={3}>
                          <Nav className="flex-column custom-nav nav-pills">
                            <NavItem>
                              <NavLink
                                href="#"
                                className={classnames({
                                  active: activeVerticalTab === 1,
                                  done:
                                    activeVerticalTab <= 11 &&
                                    activeVerticalTab > 1,
                                })}
                                onClick={() => {
                                  toggleVerticalTab(1);
                                }}
                              >
                                <span className="step-title me-2">
                                  <i className="ri-close-circle-fill step-icon me-2"></i>
                                  Step A
                                </span>
                                Job Information
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                href="#"
                                className={classnames({
                                  active: activeVerticalTab === 2,
                                  done:
                                    activeVerticalTab <= 11 &&
                                    activeVerticalTab >= 2,
                                })}
                                onClick={() => {
                                  toggleVerticalTab(2);
                                }}
                              >
                                <span className="step-title me-2">
                                  <i className="ri-close-circle-fill step-icon me-2"></i>
                                  Step B
                                </span>
                                Recurring Options
                              </NavLink>
                            </NavItem>

                            <NavItem>
                              <NavLink
                                href="#"
                                className={classnames({
                                  active: activeVerticalTab === 3,
                                  done:
                                    activeVerticalTab <= 11 &&
                                    activeVerticalTab >= 3,
                                })}
                                onClick={() => {
                                  toggleVerticalTab(3);
                                }}
                              >
                                <span className="step-title me-2">
                                  <i className="ri-close-circle-fill step-icon me-2"></i>
                                  Step C
                                </span>
                                Summary
                              </NavLink>
                            </NavItem>
                          </Nav>
                        </Col>
                        <Col lg={9}>
                          <div className="px-lg-4">
                            <TabContent activeTab={activeVerticalTab}>
                              <TabPane tabId={1}>
                                <>
                                  <div>
                                    <h5>Job Information</h5>
                                  </div>
                                  <Input type="hidden" id="id-field" />
                                  <Row className="g-3">
                                    <Col lg={12}>
                                      <div>
                                        <Label
                                          htmlFor="name-field"
                                          className="form-label"
                                        >
                                          Job Title
                                          <span className={"text-danger"}>
                                            *
                                          </span>
                                        </Label>

                                        <Input
                                          name="Title"
                                          id="Title"
                                          className="form-control"
                                          placeholder={
                                            isEdit
                                              ? jobCreateEdit?.Title
                                              : `Create Job Title`
                                          }
                                          type="text"
                                          onChange={(e) => {
                                            setJobCreateEdit({
                                              ...jobCreateEdit,
                                              Title: e.target.value,
                                            });
                                          }}
                                          value={jobCreateEdit?.Title}
                                        />
                                      </div>
                                    </Col>
                                    <Col lg={12}>
                                      <div>
                                        <Label
                                          htmlFor="company_name-field"
                                          className="form-label"
                                        >
                                          Job Description
                                        </Label>
                                        <RichTextEditor
                                          autoFocus={false}
                                          initialValue={
                                            jobCreateEdit.Description
                                          }
                                          placeholder={
                                            isEdit
                                              ? jobCreateEdit.Description
                                              : `Create Job Description`
                                          }
                                          handleContentChange={(e) => {
                                            setJobCreateEdit({
                                              ...jobCreateEdit,
                                              Description: e,
                                            });
                                          }}
                                          receivedContent={
                                            singleJobEditData?.Description
                                          }
                                          isClearEditor={isClearEditor}
                                          setIsClearEditor={setIsClearEditor}
                                        />
                                      </div>
                                    </Col>
                                    <Col lg={12}>
                                      <Label>Invoice Summary Text</Label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder={
                                          isEdit
                                            ? jobCreateEdit?.InvoiceSummaryText
                                            : `Create Invoice Summary Text`
                                        }
                                        onChange={(e) => {
                                          setJobCreateEdit({
                                            ...jobCreateEdit,
                                            InvoiceSummaryText: e.target.value,
                                          });
                                        }}
                                        value={
                                          jobCreateEdit?.InvoiceSummaryText
                                        }
                                      />
                                    </Col>

                                    <Col lg={12}>
                                      <div>
                                        <Label
                                          htmlFor="company_name-field"
                                          className="form-label"
                                        >
                                          Select Customer
                                          <span className={"text-danger"}>
                                            *
                                          </span>
                                        </Label>
                                        <div>
                                          <Select
                                            className="mb-0 job-select2"
                                            value={
                                              jobCreateEdit.Customer_Id
                                                ? {
                                                    label: customersList?.find(
                                                      (item) =>
                                                        item.Id ===
                                                        jobCreateEdit.Customer_Id
                                                    )?.FullName,
                                                    value:
                                                      jobCreateEdit.Customer_Id,
                                                    id: jobCreateEdit.Customer_Id,
                                                  }
                                                : []
                                            }
                                            onChange={(e) => {
                                              setJobCreateEdit({
                                                ...jobCreateEdit,
                                                Customer_Id: e.value,
                                              });
                                            }}
                                            options={
                                              !isEmpty(customersList)
                                                ? customersList?.map(
                                                    (item) => ({
                                                      label: item.FullName,
                                                      value: item.Id,
                                                      id: item.Id,
                                                    })
                                                  )
                                                : []
                                            }
                                            id="country-select"
                                          ></Select>
                                        </div>
                                      </div>
                                    </Col>
                                    {jobCreateEdit?.Customer_Id && (
                                      <Col lg={12}>
                                        <div>
                                          <Label
                                            htmlFor="company_name-field"
                                            className="form-label"
                                          >
                                            Customer Reference
                                          </Label>
                                          <Input
                                            name="CustomerReference"
                                            id="CustomerReference"
                                            className="form-control"
                                            placeholder={
                                              isEdit
                                                ? jobCreateEdit?.CustomerReference
                                                : `Create Customer Reference`
                                            }
                                            type="text"
                                            onChange={(e) => {
                                              setJobCreateEdit({
                                                ...jobCreateEdit,
                                                CustomerReference:
                                                  e.target.value,
                                              });
                                            }}
                                            value={
                                              jobCreateEdit?.CustomerReference
                                            }
                                          />
                                        </div>
                                      </Col>
                                    )}
                                    {jobCreateEdit.Customer_Id &&
                                      !isEmpty(PeopleList) && (
                                        <Col lg={12}>
                                          <div>
                                            <Label
                                              htmlFor="company_name-field"
                                              className="form-label"
                                            >
                                              People
                                            </Label>
                                            <div>
                                              <Select
                                                className="mb-0 job-select2"
                                                value={
                                                  jobCreateEdit.Person_Id
                                                    ? {
                                                        label: PeopleList?.find(
                                                          (item) =>
                                                            item.Id ===
                                                            jobCreateEdit.Person_Id
                                                        )?.FullName,
                                                        value:
                                                          jobCreateEdit.Person_Id,
                                                        id: jobCreateEdit.Person_Id,
                                                      }
                                                    : []
                                                }
                                                onChange={(e) => {
                                                  setJobCreateEdit({
                                                    ...jobCreateEdit,
                                                    Person_Id: e.value,
                                                  });
                                                }}
                                                options={
                                                  !isEmpty(PeopleList)
                                                    ? PeopleList?.map(
                                                        (item) => ({
                                                          label: item.FullName,
                                                          value: item.Id,
                                                          id: item.Id,
                                                        })
                                                      )
                                                    : []
                                                }
                                                id="country-select"
                                              ></Select>
                                            </div>
                                          </div>
                                        </Col>
                                      )}

                                    <Col lg={12}>
                                      <div>
                                        <Label
                                          htmlFor="company_name-field"
                                          className="form-label"
                                        >
                                          Staff
                                        </Label>
                                        <div>
                                          <Select
                                            className="mb-0 job-select2"
                                            value={
                                              jobCreateEdit.Staff_Id
                                                ? {
                                                    label:
                                                      staffData?.find(
                                                        (item) =>
                                                          item.Id ===
                                                          jobCreateEdit.Staff_Id
                                                      )?.FirstName +
                                                      " " +
                                                      staffData?.find(
                                                        (item) =>
                                                          item.Id ===
                                                          jobCreateEdit.Staff_Id
                                                      )?.LastName,
                                                    value:
                                                      jobCreateEdit.Staff_Id,
                                                    id: jobCreateEdit.Staff_Id,
                                                  }
                                                : []
                                            }
                                            onChange={(e) => {
                                              setJobCreateEdit({
                                                ...jobCreateEdit,
                                                Staff_Id: e.value,
                                              });
                                            }}
                                            options={
                                              !isEmpty(staffData)
                                                ? filterActiveStaff(staffData, [
                                                    jobCreateEdit.Staff_Id,
                                                  ])?.map((item) => ({
                                                    label:
                                                      item?.FirstName +
                                                      " " +
                                                      item?.LastName,
                                                    value: item?.Id,
                                                    id: item?.Id,
                                                  }))
                                                : []
                                            }
                                            id="country-select"
                                          ></Select>
                                        </div>
                                      </div>
                                    </Col>
                                    {isSystemModuleActive(
                                      SYSTEM_MODULE_CODES.CUSTOMER_VEHICLE
                                    ) && (
                                    <Col lg={12}>
                                      <Label>Select Vehicle</Label>
                                      <CustomSelect
                                        style={{ maxWidth: "770px" }}
                                        value={
                                          jobCreateEdit?.CustomerSiteLocation_Id
                                        }
                                        placeholder={
                                          jobCreateEdit?.Vehicle_Id
                                            ? "#" +
                                              jobCreateEdit?.Vehicle_Id +
                                              " " +
                                              (vehicleListAPI?.find(
                                                (item) =>
                                                  item.Id ===
                                                  jobCreateEdit.Vehicle_Id
                                              )?.Title
                                                ? " " +
                                                  vehicleListAPI?.find(
                                                    (item) =>
                                                      item.Id ===
                                                      jobCreateEdit.Vehicle_Id
                                                  )?.Title
                                                : "") +
                                              (vehicleListAPI?.find(
                                                (item) =>
                                                  item.Id ===
                                                  jobCreateEdit.Vehicle_Id
                                              )?.RegistrationPlate
                                                ? "Reg: " +
                                                  vehicleListAPI?.find(
                                                    (item) =>
                                                      item.Id ===
                                                      jobCreateEdit.Vehicle_Id
                                                  )?.RegistrationPlate
                                                : "") +
                                              " " +
                                              (vehicleListAPI?.find(
                                                (item) =>
                                                  item.Id ===
                                                  jobCreateEdit.Vehicle_Id
                                              )?.MinistryId
                                                ? "[MinstrId: " +
                                                  vehicleListAPI?.find(
                                                    (item) =>
                                                      item.Id ===
                                                      jobCreateEdit.Vehicle_Id
                                                  )?.MinistryId +
                                                  " ]"
                                                : "")
                                            : "Select..."
                                        }
                                        onClickCallBack={(e) => {
                                          if (!e) {
                                            setJobCreateEdit({
                                              ...jobCreateEdit,
                                              Vehicle_Id: null,
                                            });
                                            return;
                                          }
                                          setJobCreateEdit({
                                            ...jobCreateEdit,
                                            Vehicle_Id: e.value,
                                          });
                                        }}
                                        options={
                                          !isEmpty(vehicleListAPI)
                                            ? vehicleListAPI?.map((item) => ({
                                                firstLine: {
                                                  label:
                                                    "#" +
                                                    item?.Id +
                                                    //Title
                                                    (item?.Title
                                                      ? " " + item?.Title
                                                      : "") +
                                                    " " +
                                                    (item?.RegistrationPlate
                                                      ? "Reg: " +
                                                        item?.RegistrationPlate
                                                      : "") +
                                                    " " +
                                                    (item?.MinistryId
                                                      ? "[MinstrId: " +
                                                        item?.MinistryId +
                                                        " ]"
                                                      : ""),
                                                },
                                                secondLine: {
                                                  label:
                                                    (item?.Make
                                                      ? "Make: " + item?.Make
                                                      : "") +
                                                    (item?.Model
                                                      ? " Model: " + item?.Model
                                                      : "") +
                                                    //VehicleType_Name
                                                    (item?.VehicleType_Name
                                                      ? " Type: " +
                                                        item?.VehicleType_Name
                                                      : "") +
                                                    (item?.ModelYear
                                                      ? " Year: " +
                                                        item?.ModelYear
                                                      : "") +
                                                    (item?.Mileage
                                                      ? " Mileage: " +
                                                        item?.Mileage
                                                      : "") +
                                                    (item?.MinistryId
                                                      ? " MinistryId: " +
                                                        item?.MinistryId
                                                      : ""),
                                                },
                                                value: item?.Id,
                                                id: item?.Id,
                                                item,
                                              }))
                                            : []
                                        }
                                        addNewItem={true}
                                        addNewItemCallBack={() => {
                                          toggleVehicle();
                                        }}
                                      />
                                    </Col>
                                    )}
                                    <Col lg={12}>
                                      <div>
                                        <Label
                                          htmlFor="company_name-field"
                                          className="form-label"
                                        >
                                          Job Status
                                          <span className={"text-danger"}>
                                            *
                                          </span>
                                        </Label>

                                        <div>
                                          <Select
                                            className="mb-0 job-select2"
                                            value={
                                              jobCreateEdit?.JobStatus_Id
                                                ? {
                                                    label: jobStatusList?.find(
                                                      (item) =>
                                                        item.Id ===
                                                        jobCreateEdit.JobStatus_Id
                                                    )?.Name,
                                                  }
                                                : []
                                            }
                                            onChange={(e) => {
                                              setJobCreateEdit({
                                                ...jobCreateEdit,
                                                JobStatus_Id: e.value,
                                              });
                                            }}
                                            options={
                                              !isEmpty(jobStatusList)
                                                ? jobStatusList?.map(
                                                    (item) => ({
                                                      label: item.Name,
                                                      value: item.Id,
                                                      id: item.Id,
                                                    })
                                                  )
                                                : []
                                            }
                                            id="country-select"
                                          ></Select>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col lg={12}>
                                      <div>
                                        <Label
                                          htmlFor="company_name-field"
                                          className="form-label"
                                        >
                                          Job Type
                                        </Label>

                                        <div>
                                          <Select
                                            className="mb-0 job-select2"
                                            value={
                                              jobCreateEdit?.JobType_Id
                                                ? {
                                                    label: jobsTypeList?.find(
                                                      (item) =>
                                                        item.Id ===
                                                        jobCreateEdit.JobType_Id
                                                    )?.Name,
                                                    value:
                                                      jobCreateEdit.JobType_Id,
                                                    id: jobCreateEdit.JobType_Id,
                                                  }
                                                : []
                                            }
                                            onChange={(e) => {
                                              setJobCreateEdit({
                                                ...jobCreateEdit,
                                                JobType_Id: e.value,
                                              });
                                            }}
                                            options={
                                              !isEmpty(jobsTypeList)
                                                ? jobsTypeList?.map((item) => ({
                                                    label: item?.Name,
                                                    value: item?.Id,
                                                    id: item?.Id,
                                                  }))
                                                : []
                                            }
                                            id="country-select"
                                          ></Select>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col lg={12}>
                                      <div>
                                        <Label
                                          htmlFor="company_name-field"
                                          className="form-label"
                                        >
                                          Job Priority
                                        </Label>

                                        <div>
                                          <Select
                                            className="mb-0 job-select2"
                                            value={
                                              jobCreateEdit?.JobPriority_Id
                                                ? {
                                                    label:
                                                      jobPriorityList?.find(
                                                        (item) =>
                                                          item.Id ===
                                                          jobCreateEdit.JobPriority_Id
                                                      )?.Name,
                                                    value:
                                                      jobCreateEdit.JobPriority_Id,
                                                    id: jobCreateEdit.JobPriority_Id,
                                                  }
                                                : []
                                            }
                                            onChange={(e) => {
                                              setJobCreateEdit({
                                                ...jobCreateEdit,
                                                JobPriority_Id: e.value,
                                              });
                                            }}
                                            options={
                                              !isEmpty(jobPriorityList)
                                                ? jobPriorityList?.map(
                                                    (item) => ({
                                                      label: item?.Name,
                                                      value: item?.Id,
                                                      id: item?.Id,
                                                    })
                                                  )
                                                : []
                                            }
                                            id="country-select"
                                          ></Select>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col lg={12}>
                                      <div>
                                        <Label
                                          htmlFor="company_name-field"
                                          className="form-label"
                                        >
                                          Contract Item
                                        </Label>

                                        <div>
                                          <CustomSelect
                                            value={
                                              jobCreateEdit?.ContractItem_Id
                                            }
                                            placeholder={
                                              jobCreateEdit?.ContractItem_Id
                                                ? "#" +
                                                  jobCreateEdit?.ContractItem_Id +
                                                  " " +
                                                  (contractItemsList?.find(
                                                    (item) =>
                                                      item.Id ===
                                                      jobCreateEdit.ContractItem_Id
                                                  )?.Title
                                                    ? contractItemsList?.find(
                                                        (item) =>
                                                          item.Id ===
                                                          jobCreateEdit.ContractItem_Id
                                                      )?.Title + " "
                                                    : "") +
                                                  " " +
                                                  (contractItemsList?.find(
                                                    (item) =>
                                                      item.Id ===
                                                      jobCreateEdit.ContractItem_Id
                                                  )?.Customer_FullName
                                                    ? contractItemsList?.find(
                                                        (item) =>
                                                          item.Id ===
                                                          jobCreateEdit.ContractItem_Id
                                                      )?.Customer_FullName
                                                    : "")
                                                : "Select..."
                                            }
                                            onClickCallBack={(e) => {
                                              if (!e) {
                                                setJobCreateEdit({
                                                  ...jobCreateEdit,
                                                  ContractItem_Id: null,
                                                });
                                                return;
                                              }
                                              setJobCreateEdit({
                                                ...jobCreateEdit,
                                                ContractItem_Id: e?.value,
                                              });
                                            }}
                                            options={
                                              !isEmpty(contractItemsList)
                                                ? contractItemsList?.map(
                                                    (item) => ({
                                                      firstLine: {
                                                        label:
                                                          "#" +
                                                          item?.Id +
                                                          " " +
                                                          item?.Title +
                                                          " for " +
                                                          item?.Customer_FullName,
                                                      },
                                                      secondLine: {
                                                        label:
                                                          "£ " +
                                                          item?.AmountLocalEach +
                                                          " " +
                                                          item?.Product_Name +
                                                          " " +
                                                          item?.ZContractUnitFrequency_Name,
                                                      },
                                                      value: item?.Id,
                                                      id: item?.Id,
                                                      item,
                                                    })
                                                  )
                                                : []
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                    {jobCreateEdit.ContractItem_Id && (
                                      <Col lg={12}>
                                        <div>
                                          <Label
                                            htmlFor="company_name-field"
                                            className="form-label"
                                          >
                                            Contract Usage Balance:
                                          </Label>
                                          <div>
                                            <div>
                                              <span>
                                                {handleDurationTime(
                                                  contractItemsList?.find(
                                                    (item) =>
                                                      item.Id ===
                                                      jobCreateEdit.ContractItem_Id
                                                  )?.TotalTimeMins
                                                )}{" "}
                                                {contractItemsList?.find(
                                                  (item) =>
                                                    item.Id ===
                                                    jobCreateEdit.ContractItem_Id
                                                )?.TotalTimeMins <= 0
                                                  ? "Credit"
                                                  : "Debit"}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </Col>
                                    )}
                                    {renderUploadSection()}
                                    <div className={"mt-2"}>
                                      <Label>Completed Date/Time</Label>
                                      <AppDateTimePicker
                                        value={
                                          jobCreateEdit.CompletedDateTime
                                            ? moment(
                                                jobCreateEdit.CompletedDateTime,
                                                "YYYY-MM-DD HH:mm:ss"
                                              )
                                            : null
                                        }
                                        onChange={(val) =>
                                          setJobCreateEdit({
                                            ...jobCreateEdit,
                                            CompletedDateTime:
                                              val && val.isValid()
                                                ? timeFormatDateAndTime(
                                                    val.toDate()
                                                  )
                                                : "",
                                          })
                                        }
                                        slotProps={{
                                          textField: {
                                            placeholder:
                                              "Select Completed Date/Time",
                                          },
                                        }}
                                      />
                                    </div>
                                  </Row>
                                  <div className="d-flex align-items-start gap-3 mt-4">
                                    <button
                                      type="button"
                                      className="btn btn-success btn-label right ms-auto nexttab"
                                      onClick={() => {
                                        toggleVerticalTab(
                                          activeVerticalTab + 1
                                        );
                                      }}
                                    >
                                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                      Recurring Options
                                    </button>
                                  </div>
                                </>
                              </TabPane>

                              <TabPane tabId={2}>
                                <>
                                  <div>
                                    <h5>Recurring Options</h5>
                                  </div>

                                  <div>
                                    <Row className="g-3">
                                      <Col xs={6}>
                                        <Label
                                          htmlFor="address"
                                          className="form-label"
                                        >
                                          Start Date
                                        </Label>
                                        <AppDatePicker
                                          value={
                                            jobCreateEdit?.RecurringStartDateTime
                                              ? moment(
                                                  jobCreateEdit.RecurringStartDateTime
                                                )
                                              : null
                                          }
                                          onChange={(val) =>
                                            setJobCreateEdit({
                                              ...jobCreateEdit,
                                              RecurringStartDateTime:
                                                val && val.isValid()
                                                  ? handleValidDateTime(
                                                      val.toDate()
                                                    )
                                                  : "",
                                            })
                                          }
                                          slotProps={{
                                            textField: {
                                              placeholder: "Select Start Date",
                                            },
                                          }}
                                        />
                                      </Col>
                                      <Col xs={6}>
                                        <Label
                                          htmlFor="address"
                                          className="form-label"
                                        >
                                          End Date
                                        </Label>
                                        <AppDatePicker
                                          value={
                                            jobCreateEdit?.RecurringEndDateTime
                                              ? moment(
                                                  jobCreateEdit.RecurringEndDateTime
                                                )
                                              : null
                                          }
                                          onChange={(val) =>
                                            setJobCreateEdit({
                                              ...jobCreateEdit,
                                              RecurringEndDateTime:
                                                val && val.isValid()
                                                  ? handleValidDateTime(
                                                      val.toDate()
                                                    )
                                                  : "",
                                            })
                                          }
                                          slotProps={{
                                            textField: {
                                              placeholder: "Select End Date",
                                            },
                                          }}
                                        />
                                      </Col>
                                      <Col xs={12}>
                                        <Label
                                          htmlFor="address"
                                          className="form-label"
                                        >
                                          Next Date/Time
                                        </Label>
                                        <AppDatePicker
                                          value={
                                            jobCreateEdit?.RecurringNextDateTime
                                              ? moment(
                                                  jobCreateEdit.RecurringNextDateTime
                                                )
                                              : null
                                          }
                                          onChange={(val) =>
                                            setJobCreateEdit({
                                              ...jobCreateEdit,
                                              RecurringNextDateTime:
                                                val && val.isValid()
                                                  ? handleValidDateTime(
                                                      val.toDate()
                                                    )
                                                  : "",
                                            })
                                          }
                                          slotProps={{
                                            textField: {
                                              placeholder: "Select Next Date",
                                            },
                                          }}
                                        />
                                      </Col>

                                      <Col xs={12}>
                                        <Label
                                          htmlFor="address"
                                          className="form-label"
                                        >
                                          Preferred Frequency
                                        </Label>
                                        <Select
                                          className="mb-0 job-select2"
                                          placeholder={"Select Frequency"}
                                          value={
                                            jobCreateEdit?.UnitFrequency_Id
                                              ? {
                                                  label:
                                                    ContractUnitFrequencyListApi?.find(
                                                      (item) =>
                                                        item.Id ===
                                                        jobCreateEdit.UnitFrequency_Id
                                                    )?.Name,
                                                  value:
                                                    jobCreateEdit?.UnitFrequency_Id,
                                                  id: jobCreateEdit?.UnitFrequency_Id,
                                                }
                                              : ""
                                          }
                                          onChange={(e) =>
                                            setJobCreateEdit({
                                              ...jobCreateEdit,
                                              UnitFrequency_Id: e?.id,
                                            })
                                          }
                                          options={
                                            !isEmpty(
                                              ContractUnitFrequencyListApi
                                            )
                                              ? ContractUnitFrequencyListApi?.map(
                                                  (item) => ({
                                                    label: item.Name,
                                                    value: item.Id,
                                                    id: item.Id,
                                                  })
                                                )
                                              : []
                                          }
                                          id="country-select"
                                        ></Select>
                                      </Col>
                                    </Row>
                                  </div>
                                  <div className="d-flex align-items-start gap-3 mt-4">
                                    <button
                                      type="button"
                                      className="btn btn-light btn-label previestab"
                                      onClick={() => {
                                        toggleVerticalTab(
                                          activeVerticalTab - 1
                                        );
                                      }}
                                    >
                                      <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
                                      Job Information
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-success btn-label right ms-auto nexttab"
                                      onClick={() => {
                                        toggleVerticalTab(
                                          activeVerticalTab + 1
                                        );
                                      }}
                                    >
                                      <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                      Summary
                                    </button>
                                  </div>
                                </>
                              </TabPane>

                              <TabPane tabId={3}>
                                <div>
                                  <h5>Job Summary</h5>
                                  {/*  Generate summary for jobCreateEdit object listing all  Keys and values dynamicly*/}
                                  <div className="job-summary">
                                    <div>
                                      {jobCreateEdit?.Id && (
                                        <>Id: {jobCreateEdit?.Id}</>
                                      )}
                                    </div>
                                    <div>
                                      {jobCreateEdit?.Title && (
                                        <div>Title: {jobCreateEdit?.Title}</div>
                                      )}
                                    </div>
                                    <div>
                                      {jobCreateEdit?.Description && (
                                        <div>
                                          Description:{" "}
                                          {handleRichTextOutput(
                                            jobCreateEdit?.Description
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    {jobCreateEdit?.Customer_Id && (
                                      <div>
                                        Customer:{" "}
                                        {
                                          customersList?.find(
                                            (item) =>
                                              item.id ===
                                              jobCreateEdit?.Customer_Id
                                          )?.FullName
                                        }
                                      </div>
                                    )}
                                    {jobCreateEdit?.Staff_Id && (
                                      <div>
                                        Staff:{" "}
                                        {
                                          staffData?.find(
                                            (item) =>
                                              item.id ===
                                              jobCreateEdit?.Staff_Id
                                          )?.FullName
                                        }
                                      </div>
                                    )}
                                    {jobCreateEdit?.JobStatus_Id && (
                                      <div>
                                        {
                                          jobStatusList?.find(
                                            (item) =>
                                              item.id ===
                                              jobCreateEdit?.JobStatus_Id
                                          )?.Name
                                        }
                                      </div>
                                    )}
                                    {jobCreateEdit?.JobPriority_Id && (
                                      <div>
                                        Job Priority:{" "}
                                        {
                                          jobPriorityList?.find(
                                            (item) =>
                                              item.id ===
                                              jobCreateEdit?.JobPriority_Id
                                          )?.Name
                                        }
                                      </div>
                                    )}
                                    {jobCreateEdit?.JobType_Id && (
                                      <div>
                                        Job Type:{" "}
                                        {
                                          jobsTypeList?.find(
                                            (item) =>
                                              item.id ===
                                              jobCreateEdit?.JobType_Id
                                          )?.Name
                                        }
                                      </div>
                                    )}
                                    {jobCreateEdit.ContractItem_Id && (
                                      <div>
                                        Contract Item:{" "}
                                        {
                                          contractItemsList?.find(
                                            (item) =>
                                              item.id ===
                                              jobCreateEdit?.ContractItem_Id
                                          )?.Title
                                        }
                                      </div>
                                    )}
                                    {jobCreateEdit?.RecurringStartDateTime && (
                                      <div>
                                        Recurring Start Date:{" "}
                                        {jobCreateEdit?.RecurringStartDateTime}
                                      </div>
                                    )}
                                    {jobCreateEdit?.RecurringStartDateTime && (
                                      <div>
                                        Recurring End Date:{" "}
                                        {jobCreateEdit?.RecurringEndDateTime}
                                      </div>
                                    )}
                                    {jobCreateEdit?.UnitFrequency_Id && (
                                      <div>
                                        Frequency: {""}
                                        {
                                          ContractUnitFrequencyListApi?.find(
                                            (item) =>
                                              item.Id ===
                                              jobCreateEdit?.UnitFrequency_Id
                                          )?.Name
                                        }
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </TabPane>
                            </TabContent>
                          </div>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            </Row>{" "}
          </>
        )}
      </AppModal>
    </>
  );
}
